import { Menu, MenuItem, PopoverPosition } from "@mui/material";
import { mixpanel } from "common/analytics";
import { useTranslation } from "common/locales";
import { YieldEvent } from "model";
import { Dispatch, SetStateAction } from "react";

interface Props {
  yieldEvent: YieldEvent;
  anchor: HTMLElement | null;
  anchorPosition?: PopoverPosition;
  close: () => void;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}
export default function YieldEventMoreMenu({
  yieldEvent,
  anchor,
  anchorPosition,
  close,
  setDialogOpen,
}: Props) {
  const { t } = useTranslation();
  return (
    <Menu
      anchorEl={anchor}
      anchorPosition={anchorPosition}
      anchorReference={
        anchor ? "anchorEl" : anchorPosition ? "anchorPosition" : "none"
      }
      open={anchor ? anchor.id === yieldEvent.guid : false}
      onClose={close}
      key={`fe-menu-${yieldEvent.guid}`}
    >
      <MenuItem
        key={`fe-menuitem-edit-${yieldEvent.guid}`}
        onClick={() => {
          mixpanel.track("Edit/view yield event clicked");
          setDialogOpen(true);
          close();
        }}
      >
        {t("yieldEvent.menu.editView")}
      </MenuItem>
    </Menu>
  );
}
